import React from 'react';
import PropTypes from 'prop-types';
import { i18next, dialogs } from '@yola/ws-sdk';
import { AlertDialog } from '@yola/ws-ui';

const getCaptions = () => ({
  title: i18next.t('Translation failed'),
  description: i18next.t(
    "Your page(s) couldn't be translated. Please try again or contact customer support."
  ),
  dismiss: i18next.t('Dismiss'),
  submit: i18next.t('Try again'),
});

const TranslationErrorDialog = ({ onRetry }) => {
  const captions = getCaptions();

  const handleDismiss = () => {
    dialogs.operations.hide();
  };

  const handleSubmit = () => {
    onRetry();
  };

  return (
    <AlertDialog
      onDismiss={handleDismiss}
      onSubmit={handleSubmit}
      captions={captions}
      glyph="alert-circle"
      height="auto"
      minHeight={200}
      width={358}
    />
  );
};

TranslationErrorDialog.propTypes = {
  onRetry: PropTypes.func.isRequired,
};

export default TranslationErrorDialog;
